
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mendable-api/ingestion",
      function () {
        return require("private-next-pages/mendable-api/ingestion.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mendable-api/ingestion"])
      });
    }
  